import React from 'react';
import { stateMeta, qty, who } from './reportUtils';

const frDate = (s) => (s ? s.split('-').reverse().join('/') : '');
const frDateTime = (iso) => { if (!iso) return ''; const d = new Date(iso); return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('fr-FR', { timeZone: 'Europe/Zurich', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', ''); };

const HEADERS = ['Date', 'Tâche', 'Qté demandée', 'Qté produite', 'État', 'Affectée à', 'Exécutée par', 'Terminée le', 'Motif', 'Commentaire'];
const Th = ({ children }) => <th className="px-2 py-2 text-left text-[10px] font-bold uppercase tracking-wide text-gray-400 whitespace-nowrap">{children}</th>;
const Td = ({ children, cls = '', testId }) => <td className={`px-2 py-2 text-sm align-top ${cls}`} data-testid={testId}>{children}</td>;

export const ReportRow = ({ row, onOpen }) => {
  const st = stateMeta(row.state);
  return (
    <tr onClick={() => onOpen(row)} className="border-b border-gray-100 last:border-0 cursor-pointer hover:bg-gray-50" data-testid={`report-row-${row.id}`}>
      <Td cls="whitespace-nowrap text-gray-600">{frDate(row.task_date)}</Td>
      <Td cls="font-semibold text-gray-900 min-w-[160px]" testId={`report-row-title-${row.id}`}>{row.title}{row.source === 'swipe' && <span className="ml-1.5 text-[10px] font-semibold text-amber-700">Swipe</span>}</Td>
      <Td cls="whitespace-nowrap" testId={`report-row-planned-${row.id}`}>{qty(row.planned_quantity, row.unit) || '—'}</Td>
      <Td cls="whitespace-nowrap text-emerald-700 font-semibold" testId={`report-row-actual-${row.id}`}>{qty(row.actual_quantity, row.actual_unit) || '—'}</Td>
      <Td><span className={`inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${st.cls}`} data-testid={`report-row-state-${row.id}`}>{st.label}</span></Td>
      <Td cls={who(row) ? '' : 'text-gray-400 italic'}>{who(row) || 'Non affectée'}</Td>
      <Td cls={`font-medium ${row.state === 'non_realisee' ? 'text-red-700' : 'text-emerald-700'}`} testId={`report-row-executor-${row.id}`}>{row.executed_by_name || '—'}</Td>
      <Td cls="whitespace-nowrap text-gray-600">{frDateTime(row.completed_at) || '—'}</Td>
      <Td cls="text-red-700 max-w-[220px]">{row.not_done_reason || ''}</Td>
      <Td cls="text-gray-600 max-w-[220px]">{row.collaborator_comment || ''}</Td>
    </tr>
  );
};

const ReportRows = ({ sections, onOpen }) => (
  <div className="space-y-6" data-testid="report-rows">
    {sections.map(sec => (
      <section key={sec.key} className="space-y-3" data-testid={`report-section-${sec.key}`}>
        <h3 className="font-heading text-base md:text-lg font-bold text-gray-800">{sec.label} <span className="text-gray-400 font-normal">({sec.groups.reduce((n, g) => n + g.rows.length, 0)})</span></h3>
        {sec.groups.map(g => (
          <div key={g.key} className="bg-white border border-gray-200 rounded-2xl overflow-x-auto">
            {g.key !== 'all' && <p className="px-3 pt-2 text-xs font-bold uppercase tracking-wide text-gray-400">{g.label} · {g.rows.length}</p>}
            <table className="w-full min-w-[860px]">
              <thead className="border-b border-gray-200"><tr>{HEADERS.map(h => <Th key={h}>{h}</Th>)}</tr></thead>
              <tbody>{g.rows.map(r => <ReportRow key={`${r.source}-${r.id}`} row={r} onOpen={onOpen} />)}</tbody>
            </table>
          </div>
        ))}
      </section>
    ))}
  </div>
);

export default ReportRows;
